import React from 'react';
import ExpenseRow from './ExpenseRow';
import { formatCents } from '../utils/expenseMath';

function ExpenseColumn({ group, onEdit, onDelete }) {
  const headingId = `burn-${group.id}`;
  return (
    <section className="burn-column" aria-labelledby={headingId}>
      <header className="burn-column-head">
        <h2 id={headingId} className="tool-section-title">{group.label}</h2>
        <p className="burn-column-total">
          <span>Monthly burn rate</span>
          <strong>{formatCents(group.total)}</strong>
        </p>
      </header>
      {group.list.length ? (
        <ul className="burn-list">
          {group.list.map((expense) => (
            <ExpenseRow key={expense.id} expense={expense} onEdit={onEdit} onDelete={onDelete} />
          ))}
        </ul>
      ) : (
        <p className="section-empty">No {group.label.toLowerCase()} expenses yet.</p>
      )}
    </section>
  );
}

export default ExpenseColumn;